import { ISuiteTypeCommercialFields, ISuiteTypes } from '@llws/lift-entity-interfaces';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { propertyRequest } from '@/shared/request-configs/property-request';

/**
 * Creates | Updates Unit <br>
 * API Endpoints:
 * <li>`/${payload.buildingId}/units/${payload.id}` <br> via {@link propertyRequest.put} </li>
 * <li>`/${payload.buildingId}/units/` <br> via {@link propertyRequest.post} </li>
 * @param {ISuiteTypes} payload - Suite Type to save
 */
export const save = (payload: ISuiteTypes) => (
  payload.id
    ? propertyRequest.put(`/${payload.buildingId}/units/${payload.id}`, payload)
    : propertyRequest.post(`/${payload.buildingId}/units`, payload)
);

/**
 * Saves Relation on Unit <br>
 * API Endpoints:
 * <li>`/property-api/units/${unitId}/${relation}?${(querystring || '')}` <br> via {@link adminRequest.post} </li>
 * <li>`/property-api/units/${unitId}/${relation}?${(querystring || '')}` <br> via {@link adminRequest.patch} </li>
 * <li>`/property-api/units/${unitId}/${relation}?${(querystring || '')}` <br> via {@link adminRequest.put} </li>
 * @param {('post' | 'path' | 'put')} method - based on method makes a propert request post | patch | put
 * @param {number} unitId - id of the unit
 * @param {string} relation - relation to save
 * @param {any[]}data - data to save
 * @param {string} [querystring] - optional filter query string
 */
export const saveRelation = (
  method: 'post' | 'patch' | 'put',
  unitId: number,
  relation: string,
  data: Array<any>,
  querystring?: string,
) => adminRequest[method](`/property-api/units/${unitId}/${relation}?${(querystring || '')}`, data);

/**
 * Removes Relation from the Unit <br>
 * API Endpoint - `/property-api/units/${unitId}/${relation}` <br> via {@link adminRequest.delete}
 * @param {number} unitId - id of the unit
 * @param {string} relation - relation to save
 * @param {any[]}data - data to save
 */
export const deleteRelation = (
  unitId: number,
  relation: string,
  data: number[],
) => adminRequest.delete(`/property-api/units/${unitId}/${relation}`, data);

/**
 * Creates | Updates Commercial Fields of the unit <br>
 * API Endpoints:
 * <li>`/property-api/units/${unitId}/commercial-fields` <br> via {@link adminRequest.put} </li>
 * <li>`/property-api/units/${unitId}/commercial-fields` <br> via {@link adminRequest.post} </li>
 * @param {number} unitId - id of the unit
 * @param {ISuiteTypeCommercialFields[]} data - commercial fields to save/update
 */
export const saveCommercialField = async (unitId: number, data: ISuiteTypeCommercialFields[]) => {
  if (data.length > 0) {
    const result = data[0].id
      ? await adminRequest.put(`/property-api/units/${unitId}/commercial-fields`, data)
      : await adminRequest.post(`/property-api/units/${unitId}/commercial-fields`, data);

    return result.data;
  }

  return [];
};

export default {
  save,
  saveRelation,
  deleteRelation,
  saveCommercialField,
};
